import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2db36e46&lang=scss"

const __exports__ = script;

export default __exports__